(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    function enhance() {
      // Translate only the provider error observed on the English tracking page.
      root.querySelectorAll('[x-show="errorMessage"] [x-text="errorMessage"]').forEach((message) => {
        const notFound = root.dataset.shipmentNotFound;
        if (notFound && message.textContent === 'Gönderi Bulunamadı.' && message.textContent !== notFound) {
          message.textContent = notFound;
        }
      });
      root.querySelectorAll('form').forEach((form) => {
        const order = form.querySelector('input[name="order_id"]');
        const email = form.querySelector('input[name="email"]');
        if (!order || !email || form.dataset.csaEnhanced) return;
        form.dataset.csaEnhanced = 'true';
        form.classList.add('csa-tracking__form');
        const heading = form.querySelector('h1');
        if (heading) {
          heading.textContent = root.dataset.heading;
          heading.parentElement.classList.add('csa-tracking__header');
          const brand = document.createElement('p');
          brand.className = 'csa-tracking__brand';
          brand.textContent = 'CSA';
          const description = document.createElement('p');
          description.className = 'csa-tracking__description';
          description.textContent = root.dataset.description;
          heading.before(brand);
          heading.after(description);
        }
        const row = order.parentElement.parentElement;
        row.classList.add('csa-tracking__fields');
        [[order, root.dataset.orderLabel, root.dataset.orderHelp, 'off'],
         [email, root.dataset.emailLabel, root.dataset.emailHelp, 'email']]
          .forEach(([input, title, placeholder, autocomplete]) => {
            input.id = `${root.closest('[id]').id}-${input.name}`;
            input.placeholder = placeholder;
            input.autocomplete = autocomplete;
            input.required = true;
            const label = document.createElement('label');
            label.htmlFor = input.id;
            label.textContent = title;
            input.before(label);
          });
        const button = form.querySelector('button');
        if (button) {
          button.textContent = root.dataset.trackButton;
          button.parentElement.classList.add('csa-tracking__submit');
        }
        const error = form.querySelector('[x-show="errorMessage"]');
        if (error) error.setAttribute('role', 'alert');
      });
    }
    enhance();
    // The app recreates its form when customers return from shipment results.
    new MutationObserver(enhance).observe(root, { childList: true, characterData: true, subtree: true });
  }
  document.querySelectorAll('[data-csa-tracking]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-csa-tracking]').forEach(initialize);
  });
})();
